import clsx from 'clsx'
import React from 'react'
import { FieldValues, useController } from 'react-hook-form'
import CreatableSelect from 'react-select/creatable'
import { FormGroup, FormText, Label } from 'reactstrap'
import { OutlinedSelectProps } from '../Select/OutlinedSelect'

export interface SelectOutlinedCreateableProps<T>
  extends OutlinedSelectProps<T> {
  rules?: any
  className?: string
  required?: boolean
  readOnly?: boolean
}

export const SelectOutlinedCreateable = <T extends FieldValues>(
  props: SelectOutlinedCreateableProps<T>
) => {
  let controlledProps
  let controlledFieldState
  if (props.control) {
    const { field, fieldState } = useController<T>(props)
    controlledProps = field
    controlledFieldState = fieldState
  }
  const {
    label,
    disabled,
    errorText,
    options,
    placeholder,
    isClearable,
    className,
    required,
    readOnly
  } = props

  const { name, value, onChange, onBlur } = controlledProps || props
  const ref = controlledProps?.ref

  return (
    <FormGroup>
      {label && (
        <Label for={name} className='g-outlined-select-label'>
          {label.toUpperCase()}
        </Label>
      )}

      <CreatableSelect
        id={name}
        name={name}
        label={label}
        options={options}
        value={value}
        className={className}
        required={required}
        isDisabled={disabled}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange}
        onBlur={onBlur}
        ref={ref}
        placeholder={placeholder}
        isClearable={isClearable}
      />
      <FormText className={clsx('g-textarea-error')} color='danger'>
        {errorText || controlledFieldState?.error?.message || ''}
      </FormText>
    </FormGroup>
  )
}
